import React, { PropsWithChildren } from 'react';

import styles from './button.module.scss';

interface ButtonProps extends PropsWithChildren {
  onClick?: () => void;
  type?: 'primary' | 'secondary';
  disabled?: boolean;
  className?: string;
  isCircle?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick = () => {},
  type = 'primary',
  disabled = false,
  className = '',
  children,
  isCircle = false,
}) => {
  const buttonClass = [
    className,
    styles.button,
    type === 'primary' && styles.primary__,
    type === 'secondary' && styles.secondary__,
    disabled && styles.disabled__,
    isCircle && styles.circle__,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={buttonClass} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export default Button;
